/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetLatestProcessingByFileQueryResponse, DocumentUseCasesControllerGetLatestProcessingByFilePathParams, DocumentUseCasesControllerGetLatestProcessingByFileQueryParams, DocumentUseCasesControllerGetLatestProcessingByFile400, DocumentUseCasesControllerGetLatestProcessingByFile401, DocumentUseCasesControllerGetLatestProcessingByFile403, DocumentUseCasesControllerGetLatestProcessingByFile404 } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetLatestProcessingByFile";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentUseCasesControllerGetLatestProcessingByFile } from "../../clients/document-use-casesService/documentUseCasesControllerGetLatestProcessingByFile";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentUseCasesControllerGetLatestProcessingByFileQueryKey = (fileId: DocumentUseCasesControllerGetLatestProcessingByFilePathParams["fileId"], params: DocumentUseCasesControllerGetLatestProcessingByFileQueryParams) => [{
  url: '/api/v1/documents/by-file/:fileId/latest-processing',
  params: {
    fileId: fileId
  }
}, ...(params ? [params] : [])] as const;
export type DocumentUseCasesControllerGetLatestProcessingByFileQueryKey = ReturnType<typeof documentUseCasesControllerGetLatestProcessingByFileQueryKey>;
export function documentUseCasesControllerGetLatestProcessingByFileQueryOptions(fileId: DocumentUseCasesControllerGetLatestProcessingByFilePathParams["fileId"], params: DocumentUseCasesControllerGetLatestProcessingByFileQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentUseCasesControllerGetLatestProcessingByFileQueryKey(fileId, params);
  return queryOptions<DocumentUseCasesControllerGetLatestProcessingByFileQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetLatestProcessingByFile400 | DocumentUseCasesControllerGetLatestProcessingByFile401 | DocumentUseCasesControllerGetLatestProcessingByFile403 | DocumentUseCasesControllerGetLatestProcessingByFile404>, DocumentUseCasesControllerGetLatestProcessingByFileQueryResponse, typeof queryKey>({
    enabled: !!(fileId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentUseCasesControllerGetLatestProcessingByFile(fileId, params, config);
    }
  });
}

/**
 * @description Returns the most recent blocking processing workflow for a document associated with the given file; process types that do not block readiness are excluded. The per-workflow group, including those, is on processing-status.workflows. Use ?include=steps,jobs to get related processing steps and jobs.
 * @summary Get latest blocking processing by file ID
 * {@link /api/v1/documents/by-file/:fileId/latest-processing}
 */
export function useDocumentUseCasesControllerGetLatestProcessingByFile<TData = DocumentUseCasesControllerGetLatestProcessingByFileQueryResponse, TQueryData = DocumentUseCasesControllerGetLatestProcessingByFileQueryResponse, TQueryKey extends QueryKey = DocumentUseCasesControllerGetLatestProcessingByFileQueryKey>(fileId: DocumentUseCasesControllerGetLatestProcessingByFilePathParams["fileId"], params: DocumentUseCasesControllerGetLatestProcessingByFileQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentUseCasesControllerGetLatestProcessingByFileQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetLatestProcessingByFile400 | DocumentUseCasesControllerGetLatestProcessingByFile401 | DocumentUseCasesControllerGetLatestProcessingByFile403 | DocumentUseCasesControllerGetLatestProcessingByFile404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentUseCasesControllerGetLatestProcessingByFileQueryKey(fileId, params);
  const query = useQuery({
    ...documentUseCasesControllerGetLatestProcessingByFileQueryOptions(fileId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentUseCasesControllerGetLatestProcessingByFile400 | DocumentUseCasesControllerGetLatestProcessingByFile401 | DocumentUseCasesControllerGetLatestProcessingByFile403 | DocumentUseCasesControllerGetLatestProcessingByFile404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}